import { render, staticRenderFns } from "./ResearchReportDetail.vue?vue&type=template&id=9a38b766&scoped=true&"
import script from "./ResearchReportDetail.vue?vue&type=script&lang=js&"
export * from "./ResearchReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResearchReportDetail.vue?vue&type=style&index=0&id=9a38b766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a38b766",
  null
  
)

export default component.exports